import { render, staticRenderFns } from "./RuleTip.vue?vue&type=template&id=3f64f978&scoped=true"
import script from "./RuleTip.vue?vue&type=script&setup=true&lang=js"
export * from "./RuleTip.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RuleTip.vue?vue&type=style&index=0&id=3f64f978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f64f978",
  null
  
)

export default component.exports